module.exports = __webpack_public_path__ + "static/media/HowDoesCommunitySolarWork.7e0d3984.png";